import React, { Component } from 'react'
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import classes from "./Page1.module.css";
import Slider from "react-slick";
import ReactPlayer from 'react-player/lazy'
import {Container} from "react-bootstrap";
import objects from "./page1.data.json"
import Picmodal from "./PictureModal";

class Page1 extends Component {
    constructor(props){
        super(props)

        this.state={
            currentSlide:1,
            objects:this.props.about,
            PhotoModal:false,
            photoselect:false
        }
    }

    setPhotoModalShow=(bool)=>{
        this.setState({Photomodal:bool})
      }

      setPictureSelect=(url)=>{
        this.setState({photoselect:url})
      }

    /**
     * 
     * 
     * <a href="https://ibb.co/ZSdD6qS"><img src="https://i.ibb.co/NrxB6cr/carousel2.jpg" alt="carousel2" border="0"></a>
        <a href="https://ibb.co/s1X0PJK"><img src="https://i.ibb.co/myPLBF9/HW.jpg" alt="HW" border="0"></a>
        <a href="https://ibb.co/pvFKM3G"><img src="https://i.ibb.co/XZR5KzN/RW123.jpg" alt="RW123" border="0"></a>
        <a href="https://ibb.co/L8QgMTb"><img src="https://i.ibb.co/f28Nb3B/Cell1.jpg" alt="Cell1" border="0"></a>
        <a href="https://ibb.co/pXZK8v6"><img src="https://i.ibb.co/0JZ9Sjp/robowars2.jpg" alt="robowars2" border="0"></a>
     */

    render() {
        const {objects} =this.state
        // console.log(this.state.objects.photos)
        const setting = {
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            speed: 500,
            autoplaySpeed: 5000,
            cssEase: "linear",
            lazyLoad: false,
            className: "center",
            // centerMode: true,
            pauseOnHover: true,
            adaptiveHeight: true
          };
          const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2500,
            // centerMode: true,
            
            // lazyLoad: true,
          };

        
        return (
            <div className={classes.Light} onLoad={()=>{window.scrollTo(0, 1000);}}>
            <div style={{paddingTop:"35px"} }>
            <Picmodal show={this.state.PhotoModal} onHide={() =>{this.setPhotoModalShow(false)}} image={this.state.photoselect}></Picmodal>
                <Slider {...settings} >
                    {objects.photos.map((photo,index)=>{
                        return(
                            <div key={index} onDrag={()=>{this.setPictureSelect(photo.url);this.setPhotoModalShow(true);}}>
                                <img src={photo.url} alt={photo.name} className={classes.caroImages} ></img>
                            </div>
                            // style={{width:"100%", minHeight:"60vh"}}
                            // style={{width:"95%", minHeight:"60vh",margin:'auto'}}
                            // style={{alignContent:'center',alignItems:'center',textAlign:'center',margin:'auto'}}
                        )
                    })}
                </Slider>
            </div>
                <Container style={{paddingTop:'20px'}}> 
                <h1>{objects.para[0].title}</h1>
                <br></br>
                <p>
                   {objects.para[0].body} 
                </p>
                </Container>
                <br></br>
            <div className={classes.dark}>
            <Container> 
            <br></br>
            <br></br>
                <h1>{objects.para[1].title}</h1>
                <br></br>
                <p>
                    {objects.para[1].body}
                </p>
                </Container>
            <div style={{padding:40} }>
                <Slider {...setting} >
                    {objects.videos.map((video,index)=>{
                        return(
                            <div align='center' key={index}>
                                <ReactPlayer controls width='90vw' height="40vw" url={video.url} />
                            </div> 
                        );
                    })}
                </Slider>
            </div>
            </div>
        </div>
        )
    }
}

export default Page1
